import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import { useCompareValuesPerYearPerMonthPercentage } from './hooks/useCompareValuesPerYearPerMonthPercentage';

export const CompareValuesPerYearPerMonthPercentage = () => {
    const { chartConfig } = useCompareValuesPerYearPerMonthPercentage();
    
    return (
        <ChartContainer
            title={`Evolução do Índice de Eficácia entre a Quantidade Aprovada e a Quantidade Produzida`}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={320}
        />
    );
};
